import { render } from "./HospitalSettings.vue?vue&type=template&id=2155ec93"
import script from "./HospitalSettings.vue?vue&type=script&lang=js"
export * from "./HospitalSettings.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hospitals/settings/HospitalSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2155ec93"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2155ec93', __exports__)) {
    console.log('reload')
    api.reload('2155ec93', __exports__)
  }
  
  module.hot.accept("./HospitalSettings.vue?vue&type=template&id=2155ec93", () => {
    console.log('re-render')
    api.rerender('2155ec93', render)
  })

}


export default __exports__